export default "__VITE_ASSET__c208587b__"